import {onePathIcons} from './SvgPathIcons'

export default {
    'homepage': 'fas fa-home',
    'save': 'far fa-save',              //far fa-save
    'reload': 'fas fa-redo-alt',         //fas fa-redo-alt
    'new': 'far fa-file',               //far fa-file
    'edit': 'far fa-edit',              //far fa-edit
    'delete': 'far fa-trash-alt',        //far fa-trash-alt
    'confirm': 'fas fa-check-double',    //fas fa-check-double
    'external_link': 'fas fa-external-link-alt',         //fas fa-external-link-alt
    'not_published': 'far fa-eye-slash',      //far fa-eye-slash
    'published': 'far fa-eye',           //far fa-eye
    'redirect': 'fas fa-directions',     //fas fa-directions
    'mail': 'far fa-envelope',           //far fa-envelope
    'clone': 'far fa-clone',            //far fa-clone
    'add': 'fas fa-plus',               //fas fa-plus
    //'info': 'fas fa-info-circle',            //fas fa-info-circle
    'more': 'fas fa-ellipsis-v',         //fas fa-ellipsis-v
    'filter': 'fas fa-filter',         //fas fa-filter
    'search': 'fas fa-search',          //fas fa-search
    'prev': 'fas fa-angle-double-left',
    'next': 'fas fa-angle-double-right',
    'edition': 'far fa-file-alt',

    'folder': 'far fa-folder',
    'collapse_down': 'fas fa-chevron-down',
    'collapse_up': 'fas fa-chevron-up',
    'properties': 'fas fa-cogs',
    'send_bulk': 'fas fa-mail-bulk',
    'send': 'far fa-paper-plane',
    'visible': 'far fa-eye',
    'back': 'fas fa-arrow-left',
    'setup': 'fas fa-cog',
    'wizard': 'fas fa-magic',
    'angle_left': 'fas fa-angle-left',
    'angle_right': 'fas fa-angle-right',
    'variables': 'fas fa-bars',
    'value_custom_params': 'fas fa-cogs',
    'sort': 'fas fa-sort',
    'link': 'fas fa-link',
    'unlink': 'fas fa-unlink',
    'pin': 'fas fa-thumbtack',
    'reset_bounce': 'fas fa-thermometer-empty',
    'close': 'fas fa-times',
    'user': 'fas fa-user',
    'users': 'fas fa-users',
    'logout': 'fas fa-sign-out-alt',
    'app_version': 'fas fa-code-branch',
    'template': 'far fa-file-code',
    'source': 'far fa-file-code',
    'vcf': 'far fa-address-card',
    'mailbox': 'fas fa-at',
    'open_holder': 'fas fa-external-link-square-alt',
    'layout': 'fas fa-border-none',
    'pageblock': 'fas fa-cube',
    'img_not_found': 'fas fa-exclamation-circle',
    'pause': 'fas fa-pause',
    'play': 'fas fa-play',
    'field_section': 'fas fa-server',
    'field_permalinks': 'fas fa-link',
    'added':'fas fa-check',

    ...onePathIcons,
}
